import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useParams } from "react-router-dom";

export const ViewScreeningAlertContext = createContext(null);

type Props = {
  children: ReactElement;
};

const ViewScreeningAlertProvider: FunctionComponent<Props> = ({ children }) => {
  const { id } = useParams();

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["view_screening_alert"],
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`backoffice/onboarding/risk-profiles/${id}`);

      return data;
    },
  });

  const {
    data: documentUploadData,
    isLoading: documentUploadLoading,
    error: documentUploadError,
    isFetching: documentUploadFetching,
  } = useQuery({
    queryKey: ["view_document_upload"],
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`backoffice/onboarding/risk-profiles/${id}/documents`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,

      documentUploadData,
      documentUploadLoading,
      documentUploadError,
      documentUploadFetching,
    }),
    [
      isLoading,
      data,
      error,
      isFetching,
      documentUploadData,
      documentUploadLoading,
      documentUploadError,
      documentUploadFetching,
    ],
  );
  return (
    <ViewScreeningAlertContext.Provider value={contextValue}>
      {children}
    </ViewScreeningAlertContext.Provider>
  );
};

export default ViewScreeningAlertProvider;
